export default function BackButton() {

    return (
        <button onClick={() => window.history.back()} className='border p-3 rounded text-sm text-gray-600 hover:scale-105 hover:bg-docpgrPurple10 hover:opacity-90'>
            Back
        </button>
    )
}